import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "./httpClient";

import { useSelector } from "react-redux";

function MultiInvestorAccount({ children }) {
  const isAuthenticated = getCookie("token");

  const profile = useSelector((store) => store.profile);
  let location = useLocation();

  if (
    (profile?.data?.institution &&
      profile?.data?.institution?.applicationStage &&
      profile?.data?.institution?.applicationStage == "approved") ||
    (profile?.data?.individual &&
      profile?.data?.individual?.applicationStage &&
      profile?.data?.individual?.applicationStage == "approved")
  ) {
    return (
      <Navigate
        to="/search/investor"
        //   state={{ from: location }} replace
      />
    );
  } else {
    return children;
  }
}

export default MultiInvestorAccount;
